/**
 * Nuxt middleware for setting the fetched state for user related information.
 * @package fun-academy-campus
 */
export default defineNuxtRouteMiddleware((): void => {
  if (import.meta.server) return;
  const { setHasFetchedProgress } = useDataStore();
  setHasFetchedProgress(false);
});
